///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { JhiAlertErrorComponent } from './alert/alert-error.component';
import { CommonModule } from '@angular/common';
import { GtthValidationAlertComponent } from './directives/validation-directives/validation-alert.component';
import { GtthCustomListBoxComponent } from './custom-lists-box/custom-list-box.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabsNavComponent } from './tabs-nav/tabs-nav.component';
import { GtthSharePipesModule } from './shared-pipes.module';
import { GtthCustomersAccordionComponent } from './customers-accordion/customers-accordion.component';
import { RouterModule } from '@angular/router';
import { GtthShareDirectivesModule } from './shared-directives.module';
import { GtthCustomerDetailsComponent } from './customer-details/customer-details.component';
import { GtthUserRoleBadgeComponent } from './user-role-badge/user-role-badge.component';
import { GtthSharedLibsModule } from './shared-libs.module';
import { GtthMultiSelectComponent } from './multi-select/multi-select.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ContextSensitiveHelpComponent } from './context-sensitive-help/ctx-sensitive-help.component';
import { HighlightTextComponent } from './global-components/highlight-text.component';
import { SuiTooltipDirective } from '@siklu/sui-lib/infrastructure';
import { SuiTranslateDirective, SuiTranslatePipe } from '@siklu/sui-lib/localization';
import { SuiSvgIconComponent } from '@siklu/sui-lib';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GtthSharePipesModule,
        GtthShareDirectivesModule,
        GtthSharedLibsModule,
        RouterModule,
        ScrollingModule,
        MatProgressBarModule,
        ContextSensitiveHelpComponent,
        TabsNavComponent,
        HighlightTextComponent,
        SuiTooltipDirective,
        SuiTranslatePipe,
        SuiTranslateDirective,
        SuiSvgIconComponent,
        JhiAlertErrorComponent,
        GtthCustomListBoxComponent
    ],
    declarations: [
        GtthValidationAlertComponent,
        GtthCustomersAccordionComponent,
        GtthCustomerDetailsComponent,
        GtthUserRoleBadgeComponent,
        GtthMultiSelectComponent
    ],
    exports: [
        JhiAlertErrorComponent,
        GtthValidationAlertComponent,
        GtthCustomListBoxComponent,
        GtthCustomersAccordionComponent,
        GtthCustomerDetailsComponent,
        GtthUserRoleBadgeComponent,
        GtthSharedLibsModule,
        GtthMultiSelectComponent,
        SuiSvgIconComponent
    ]
})
export class GtthShareComponentsModule {}
